module.exports = __webpack_public_path__ + "static/media/thankYouFeedback.4bd3ce0d.png";